import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyCzGJcHga8BYMxlhqe_k1URUSKDoI7MJHA",
  authDomain: "shopwish-45ba4.firebaseapp.com",
  projectId: "shopwish-45ba4",
  storageBucket: "shopwish-45ba4.appspot.com",
  messagingSenderId: "14062331489",
  appId: "1:14062331489:web:9bdea4bd55b9712f66ac20"
};


export const app = initializeApp(firebaseConfig);
export const auth = getAuth();
export const db = getFirestore();
export const storage = getStorage();
export const provider = new GoogleAuthProvider();